<template>
  <v-autocomplete
    :items="_years"
    :value="value"
    :label="label"
    @change="handleChange"
    :error-messages="errorMessages"
    v-bind="attributes"
    @click:append="handleChange(null)"
  ></v-autocomplete>
</template>

<script>
export default {
  props: ["value", "label", "errorMessages", "attributes"],
  data() {
    return {
      content: this.value
    };
  },
  computed: {
    _years() {
      const years = [];
      const before = Vue.moment("1900-01-01");
      const now = Vue.moment();

      while (now >= before) {
        years.push(Number(now.format("YYYY")));

        now.subtract(1, "y");
      }

      return years;
    }
  },
  methods: {
    handleChange(val) {
      this.content = val;
      this.$emit("input", this.content);
    }
  }
};
</script>

<style></style>
